<script>
export default {
  name:'ProtocolDialog',
  props: ['show', 'type'],
  data() {
    return {
      isShow: false,
    }
  },
  watch: {
    show(v){
      this.isShow = v
    },
    isShow(v){
      if(!v) this.$emit('update:show', v)
    }
  }
}
</script>

<template>
  <el-dialog :visible.sync="isShow" width="80vw">
    <iframe :src="`user/login/protocol?type=${type}`" width="100%" height="500px" frameborder="0"></iframe>
  </el-dialog>
</template>

<style scoped lang="scss">

</style>
